import { render, staticRenderFns } from "./ItemPrecos.vue?vue&type=template&id=3e0d6252&"
import script from "./ItemPrecos.vue?vue&type=script&lang=js&"
export * from "./ItemPrecos.vue?vue&type=script&lang=js&"
import style0 from "./ItemPrecos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports